import React from "react";
import { DialogMessage } from "../../ui/templates/modal";

class Message extends React.Component {
  closeMessage = () => {
    this.props.pop();
  };

  render() {
    const { message } = this.props;
    return (
      <DialogMessage
        title="Message"
        push={message}
        body={message}
        onCancel={this.closeMessage}
      />
    );
  }
}

export default Message;
